import { render, staticRenderFns } from "./stocklog.vue?vue&type=template&id=18768d94&scoped=true&"
import script from "./stocklog.vue?vue&type=script&lang=js&"
export * from "./stocklog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18768d94",
  null
  
)

export default component.exports